import { gql } from "@apollo/client";

export default gql`
  mutation CreateMergeLinkToken($integrationSlug: String!, $category: String!) {
    createMergeLinkToken(
      integrationSlug: $integrationSlug
      category: $category
    ) {
      success
      linkToken
      integrationName
      endUserOriginId
      error
    }
  }
`;
